module.exports = __webpack_public_path__ + "img/banner_topo_foto.5010910d.png";